import moment from "moment";
import { Jobs } from "../utils/types";
import parsePhoneNumberFromString from "libphonenumber-js";
import clsx from "clsx";
import { JobStatus } from "../utils/enum";

interface JobTableMobileProps {
    data: Jobs[];
    loading?: boolean;
    onPressRow?: (e: React.MouseEvent<any, MouseEvent>, row: Jobs) => void
}

export default function JobTableMobile(props: JobTableMobileProps) {
    return <>
        {props.data.map((item, index) => <>
            <div
                key={item.id}
                className="cursor-pointer mb-2 w-full rounded-md bg-white p-4"
                onClick={(e) => props.onPressRow?.(e, item)}
            >
                <div className="flex items-center justify-between border-b pb-4">
                    <div className="w-full">
                        <div className="mb-2 flex w-full items-center justify-between">
                            {/* <img className="w-14 h-14 object-contain mt-1 mb-1" src={item.imageUrl[0]} alt="Product" /> */}
                            <p className="text-xl font-medium">(#{item.id}) {item.customer_name}</p>
                            <span className={clsx("inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset", getBadgeStatusColorClass(item.job_status))}>
                                {item.job_status?.toUpperCase?.()}
                            </span>
                        </div>
                        <p className="text-sm text-gray-500">{item.customer_address}</p>
                    </div>
                </div>
                <div className="flex w-full items-center justify-between pt-4">
                    <div>
                        <p>{parsePhoneNumberFromString(item.customer_contact_number)?.formatInternational()}</p>
                        <p className="text-sm text-gray-500">Created at {moment(item.created_at).format('ll')}</p>
                    </div>
                </div>
            </div>
        </>)}
    </>
}

export function JobTableMobileSkeleton() {
    return <>{new Array(6).fill(0).map(() => <div className="mb-2 w-full rounded-md bg-white p-4">
        <div className="flex items-center justify-between border-b border-gray-100 pb-8">
            <div className="flex items-center">
                <div className="mr-2 h-8 w-8 rounded-full bg-gray-100"></div>
                <div className="h-6 w-16 rounded bg-gray-100"></div>
            </div>
            <div className="h-6 w-16 rounded bg-gray-100"></div>
        </div>
        <div className="flex w-full items-center justify-between pt-4">
            <div>
                <div className="h-6 w-16 rounded bg-gray-100"></div>
                <div className="mt-2 h-6 w-24 rounded bg-gray-100"></div>
            </div>
            <div className="flex justify-end gap-2">
                <div className="h-10 w-10 rounded bg-gray-100"></div>
                <div className="h-10 w-10 rounded bg-gray-100"></div>
            </div>
        </div>
    </div>)}
    </>
}

const getBadgeStatusColorClass = (job_status: JobStatus) => {
    if (job_status === JobStatus.PENDING) return 'bg-yellow-50 text-yellow-700 ring-yellow-600/20'
    if (job_status === JobStatus.REJECTED) return 'bg-red-50 text-red-700 ring-red-600/20'
    if (job_status !== JobStatus.ACCEPTED) return 'bg-green-50 text-green-700 ring-green-600/20'
    return 'bg-gray-50 text-gray-700 ring-gray-600/20'
}